<template>
    <div>
        <b-btn @click="downloadCSV">SpreadSheet (CSV)</b-btn>
    </div>
</template>

<script>
export default {
    name: "SDOrders",
    methods: {
        downloadCSV() {
            this.axios.get('/dashboard/sd/csv', {responseType: 'blob', })
                .then((response) => {
                    let link = document.createElement('a');
                    link.href = URL.createObjectURL(response.data);;
                    link.setAttribute('download', 'orders.csv'); //or any other extension
                    document.body.appendChild(link);
                    link.click();

                    document.body.removeChild(link);
                    URL.revokeObjectURL(href);
                });
        }
    }
}
</script>

<style scoped>

</style>